import React, { useCallback, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ConfirmDialog from "../../components/ConfirmDialog";
import { isBlank, notBlank } from "../../util/ext";
import Paper from "@material-ui/core/Paper";
import { useConfirm } from "../../common/use-confirm";
import {
  any,
  append,
  concat,
  difference,
  map,
  prop,
  propEq,
  reject,
  sortBy,
  without,
} from "ramda";
import Grid from "@material-ui/core/Grid";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import DialogContentText from "@material-ui/core/DialogContentText";
import { expandDisplayName, useSubmissionTypes } from "../cspServices";
import { caseInsensitiveSort } from "../../util/sorts";

const useStyles = makeStyles(theme => ({
  form: {
    marginTop: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

const sortSubmissionTypes = caseInsensitiveSort("displayName");

const SubmissionTypesDialog = ({ open, onCancel, onApply, project }) => {
  const classes = useStyles();

  //-- Manage the confirm dialog
  const confirmHandler = useConfirm();
  const { showConfirm } = confirmHandler;

  const [available, setAvailable] = useState([]);
  const [selected, setSelected] = useState([]);

  const submissionTypesResponse = useSubmissionTypes();
  useEffect(() => {
    if (submissionTypesResponse.isSuccess) {
      setSelected(project.submissionTypes);
      const unused = reject(
        st => any(propEq("name", st.name), project.submissionTypes),
        submissionTypesResponse.data,
      );

      setAvailable(
        sortBy(prop("name"), concat(project.submissionTypes, unused)),
      );
    }
  }, [
    submissionTypesResponse.isSuccess,
    submissionTypesResponse.data,
    project.submissionTypes,
  ]);

  const handleClose = useCallback(() => {
    const previous = notBlank(project.submissionTypes)
      ? project.submissionTypes
      : [];
    if (isBlank(difference(selected, previous))) {
      onCancel();
    } else {
      showConfirm(
        "Discard Changes?",
        "You have selected submission types without applying.  Do you wish to discard these changes?",
        {
          onConfirm: () => {
            onCancel();
          },
        },
      );
    }
  }, [selected, project.submissionTypes, showConfirm, onCancel]);

  const handleApply = useCallback(() => {
    onApply(selected);
  }, [onApply, selected]);

  const handleSelected = st => event => {
    if (event.target.checked) {
      setSelected(prev => append(st, prev));
    } else {
      setSelected(prev => without([st], prev));
    }
  };

  return (
    <Dialog open={open}>
      <DialogTitle id="add-submission-types-dialog-title">
        Update Submission Types
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Check the Submission Types that should allowed for this Project.
        </DialogContentText>
        <Paper>
          <Box className={classes.form}>
            <Grid spacing={2} container>
              {map(
                st => (
                  <Grid key={st.name} item md={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={any(propEq("name", st.name), selected)}
                          onChange={handleSelected(st)}
                          name={st.name}
                          color="primary"
                        />
                      }
                      label={expandDisplayName(st)}
                    />
                  </Grid>
                ),
                sortSubmissionTypes(available),
              )}
            </Grid>
          </Box>
        </Paper>
        <ConfirmDialog handler={confirmHandler} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleApply} color="primary">
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubmissionTypesDialog;
